module.exports = __webpack_public_path__ + "static/media/rh.61afa8b5.svg";